import React from 'react'
import "../styles/homeSliders.css"

export const HomeSliders = () => {
  return (
    <div className="mainHomeItems">
      <div className="homeItems">
        <h1>Handpicked Collections for You</h1>

        <div className="Handpicked">
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/tiow_img/mmt/activities/m_Courtyard%20by%20Mariott%20Aravali%20Resort_Gothda%20Mohbtabad_Faridabad_p_1920_1080.jpg" alt="" />
            <button>TOP 8</button>
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/Luar%20Chalet/mmt/activities/m_Luar%20Chalet_p_1920_1080.jpg" alt="" />
            <button>TOP 8</button>
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/Le%20ROI%20Floating%20Huts%20&%20Eco%20Rooms,%20Tehri,%20Uttarakhand/mmt/activities/m_Le%20ROI%20Floating%20Huts%20&%20Eco%20Rooms,%20Tehri,%20Uttarakhand_p_1920_1080.jpg" alt="" />
            <button>TOP 8</button>
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/tiow_img/mmt/activities/m_Neemrana_s_Tijara%20Fort%20Palace_Near%20Alwar_Rajasthan_p_1920_1080.jpg" alt="" />
            <button>TOP 8</button>
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/Delhi%20Hotel%20Collections/mmt/activities/m_Itsy%20Bitsy%20Cabin%20Dome-shaped%20Cabin%20Kasol_p_1920_1080.jpg" alt="" />
            <button>TOP 8</button>
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
        </div>

      </div>


      <div className="homeItems">
        <h1>Unlock Lesser-Known Wonders of India</h1>

        <div className="Handpicked">
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/yeracaud/mmt/activities/t_ufs/m_activities_Yeracaud_Emerald%20Lake_l_400_640.jpg" alt="" />
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/yercaud/mmt/activities/t_ufs/m_activities-yercaud-kiliyur-falls_l_400_640.jpg" alt="" />
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/yeracaud/mmt/activities/t_ufs/m_activities_Yeracaud_Anna%20Park_l_308_493.jpg" alt="" />
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/yeracaud/mmt/activities/t_ufs/m_activities_Yeracaud_Sri%20Raja%20Rajeswari%20Temple_l_391_625.jpg" alt="" />
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
          <div className="HandpickedCard">
            <img src="https://hblimg.mmtcdn.com/content/hubble/img/yeracaud/mmt/activities/t_ufs/m_activities_Yeracaud_Montfort%20School_l_400_640.jpg" alt="" />
            <h2>Stays in & Around Delhi for a Weekend Getaway</h2>
          </div>
        </div>

      </div>



    </div>
  )
}
